/* eslint-disable max-lines */
/* eslint-disable max-len */
import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import '../styles.scss';
import {Filter, FloatingSummaryColumnFilter} from './TableFilters';
import {Link} from 'react-router-dom';
import {jsonToParams} from '../../utils/commonUtils';

const renderCell = ({row, filters, id}) => {
  const params = {
    'group': id,
    'master': row.original.master,
    'sfx': row.original.sfx,
    'dealer': filters.dealer,
    'reservationAdvance': filters.reservationAdvance,
    'antiquity': filters.antiquity,
  };
  return (
    <Link
      className='no-space'
      to={`/vehiculos/inventario-flotante?${jsonToParams(params)}`}
    >
      {row.original[id] || 0}
    </Link>
  );
};

const transitColumns = (filters, isUserTde) => {
  const dealerHiddenColums = ['transitNotAvailable'];
  const columns = [
    {
      'Header': () => <span className="header-title">NO DISPONIBLES</span>,
      'accessor': 'transitNotAvailable',
      'className': 'cell-custom-inventory-models link-cell border-left border-right-internal',
      'groupClassName': 'color-group-transit border-left border-right-internal',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitNotAvailable'}),
    },
    {
      'Header': () => <span className="header-title">DEPÓSITO</span>,
      'accessor': 'transitDeposit',
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-transit',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitDeposit'}),
    },
    {
      'Header': () => <span className="header-title">TRÁNSITO</span>,
      'accessor': 'transitTransit',
      'className': 'cell-custom-inventory-models link-cell border-right',
      'groupClassName': 'color-group-transit',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitTransit'}),
    },
    {
      'Header': () => <span className="header-title">TOTAL</span>,
      'accessor': 'transitTotal',
      'className': 'cell-custom-inventory-models link-cell border-right color-total',
      'groupClassName': 'color-group-transit',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitTotal'}),
    },
    {
      'Header': () => <span className="header-title">LIBRES</span>,
      'accessor': 'transitFree',
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-transit',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitFree'}),
    },
    {
      'Header': () => <span className="header-title">RESERVADAS</span>,
      'accessor': 'transitReservations',
      'className': 'cell-custom-inventory-models link-cell border-right',
      'groupClassName': 'color-group-transit border-right',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'transitReservations'}),
    },
  ];
  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !dealerHiddenColums.includes(column.accessor));
};


const depositColumns = (filters, isUserTde) => {
  const dealerHiddenColums = ['depositNotAvailable'];
  const columns = [
    {
      'Header': () => <span className="header-title">NO DISPONIBLES</span>,
      'accessor': 'depositNotAvailable',
      'className': 'cell-custom-inventory-models link-cell border-right-internal',
      'groupClassName': 'color-group-stock border-right-internal',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'depositNotAvailable'}),
    },
    {
      'Header': () => <span className="header-title">LIBRES</span>,
      'accessor': 'depositFree',
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'depositFree'}),
    },
    {
      'Header': () => <span className="header-title">RESERVADAS</span>,
      'accessor': 'depositReservations',
      'className': 'cell-custom-inventory-models link-cell border-right',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'depositReservations'}),
    },
    {
      'Header': () => <span className="header-title">TOTAL</span>,
      'accessor': 'depositTotal',
      'className': 'cell-custom-inventory-models link-cell border-right color-total',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'depositTotal'}),
    },
    {
      'Header': () => <span className="header-title">SOL. NAC.</span>,
      'accessor': 'depositSolNac',
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => renderCell({row, filters, 'id': 'depositSolNac'}),
    },
  ];
  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !dealerHiddenColums.includes(column.accessor));
};

const tableHeaderWithProps = ({filters, isUserTde}) => {
  return [
    {
      'Header': () => <span className="header-title"></span>,
      'id': 'total',
      'columns': [
        {
          'Header': () => <span className="header-title">MODELO</span>,
          'accessor': 'description',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-big align-left',
        },
        {
          'Header': () => <span className="header-title">KATASHIKI</span>,
          'accessor': 'master',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-big',
        },
        {
          'Header': () => <span className="header-title">SFX</span>,
          'accessor': 'sfx',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-medium',
        },
      ],
    },
    {
      'Header': () => <span className="header-title">TRÁNSITO</span>,
      'id': 'transitGroup',
      'groupClassName': 'color-group-transit border-right border-left',
      'columns': transitColumns(filters, isUserTde),
    },
    {
      'Header': () => <span className="header-title">DEPÓSITO</span>,
      'id': 'depositGroup',
      'groupClassName': 'color-group-stock border-right',
      'columns': depositColumns(filters, isUserTde),
    },
  ];
};

const FloatingSummaryTable = ({dataTable, isUserTde, loading, filters}) => {
  const clone = cloneDeep(dataTable);
  const columnsTable = tableHeaderWithProps({filters, isUserTde});
  const data = useMemo(() => clone, [dataTable]);
  const columns = useMemo(() => columnsTable, [filters]);

  const {getTableProps, getTableBodyProps, headerGroups, prepareRow, page} =
    useTable(
      {
        columns,
        data,
        'defaultColumn': {'Filter': FloatingSummaryColumnFilter},
        'initialState': {'pageIndex': 0, 'pageSize': 100000},
        'requestData': filters,
      },
      useFilters,
      usePagination,
      useRowSelect
    );

  return (
    <>
      <div className="table-wrapper floating-summary-table">
        <Table className="interactive" compact {...getTableProps()}>
          <Table.Header className="sticky z-index-10">
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  return (
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign="center"
                      className= {`${column.groupClassName} th-semanctic-custom`}
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell>
                  );
                })}
              </Table.Row>
            ))}
            {
              !loading && (
                <Table.Row key="filters" id="filters">
                  {headerGroups[1].headers.map((column, index) => {
                    return (
                      <Table.HeaderCell
                        key={`filter-${index}`}
                        textAlign="center"
                        className={`${[3, 6, 9].includes(index) ? 'border-left' : 'none'}`}>
                        <Filter column={column} />
                      </Table.HeaderCell>
                    );
                  }
                  )}
                </Table.Row>
              )
            }
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            { loading ? (
              <Table.Cell colSpan={15} textAlign="center">
                Espere...
              </Table.Cell>
            ) :
              (<>
                {!page.length && (
                  <Table.Row>
                    <Table.Cell colSpan={15} textAlign="center">
                      No hay datos disponibles
                    </Table.Cell>
                  </Table.Row>
                )}
                {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row
                    key={i}
                    className={`
                      row-custom cell-custom-inventory-models ${i % 2 === 0 ? 'table-row-odd' : 'table-row-even'}
                    `}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell
                          textAlign="center"
                          className={cell.column.className}
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
              </>)
            }
            
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  'isUserTde': state.session.isUserFromTDE,
});

const {fetchOrigins} = Actions;

export default connect(mapStateToProps, {
  fetchOrigins,
})(FloatingSummaryTable);
